import React, { useEffect, useState } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import './home.scss';
import messenger from '../../services/messenger';
import GamesWidgetContainer from '../../containers/games-widget-container/games-widget-container';

const HomeView = ({ closable }) => {
	let [opened, setOpened] = useState(true);
	const history = useHistory();

	useEffect(() => {
		window.addEventListener('message', (e) => {
			try {
				const msg = JSON.parse(e.data);
				if (msg.type === 'openWidget')
					setOpened(true);
				else if (msg.type === 'closeWidget')
					setOpened(false);
			} catch {

			}
		});
	}, []);

	useEffect(() => {
		!opened && setTimeout(() => {
			messenger.sendMessage('closeWidget');
		}, 950);
	}, [opened]);

	const toggleOpened = () => {
		history.push('/');
		closable && setOpened(!opened)
	}

	return (
		<div className={`home-view ${opened ? 'opened' : 'closed'}`}>
			<Switch>
				<Route path="/" exact component={props => <GamesWidgetContainer {...props} />} />
				<Route
					path="/search/:name"
					component={props => <GamesWidgetContainer {...props} />} />
			</Switch>
		</div>
	);
};

export default HomeView;
